import http from "../http"
import { CreateLeagueDTO, League, UpdateLeagueDTO } from "../../models/league"

class AdminLeagueService {
  private readonly baseUrl = "/admin"

  async updateLeague(id: string, dto: UpdateLeagueDTO) {
    await http.put(`${this.baseUrl}/league/${id}`, dto)
  }

  async createLeague(dto: CreateLeagueDTO) {
    const { data } = await http.post<League>(`${this.baseUrl}/league`, dto)
    return data
  }

  async deleteLeague(id: string) {
    await http.delete(`${this.baseUrl}/league/${id}`)
  }

  // League Teams
  async AddTeamToLeague(leagueId: string, teamId: string) {
    const { data } = await http.post(`${this.baseUrl}/league/${leagueId}/team/${teamId}`)
    return data
  }

  async RemoveTeamFromLeague(leagueId: string, teamId: string) {
    const { data } = await http.delete(`${this.baseUrl}/league/${leagueId}/team/${teamId}`)
    return data
  }

  // League Fixtures
  async startLeague(leagueId: string) {
    const { data } = await http.post(`${this.baseUrl}/league/${leagueId}/start`)
    return data
  }

  async deleteFixtures(leagueId: string) {
    const { data } = await http.delete(`${this.baseUrl}/league/${leagueId}/fixture`)
    return data
  }

  // League Stats
  async clearPlayerStats(leagueId: string, userId: string) {
    await http.delete(`${this.baseUrl}/league/${leagueId}/user/${userId}/stats`)
  }

  async updateLeagueStats(leagueId: string) {
    await http.put(`${this.baseUrl}/league/${leagueId}/stats`)
  }

  // League End
  async endLeague(leagueId: string) {
    await http.put(`${this.baseUrl}/league/${leagueId}/end`)
  }
}

export default new AdminLeagueService()
